<template>
    <div class="upload">
        <audio-upload />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AudioUpload from '@/components/AudioUpload.vue';

export default defineComponent({
    name: 'UploadView',
    components: {
        AudioUpload
    }
});
</script>
